<template>
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between" style="cursor: pointer;" @click="toggle">
      <slot v-if="$slots.header" name="header" />
      <span v-else class="font-weight-semibold" style="font-size: 16px;">{{ title }}</span>
      <div class="d-flex align-items-center" style="gap: 24px;">
        <slot v-if="isExpanded" name="title"></slot>
        <div class="expandButton d-flex align-items-center justify-content-center">
          <i :class="!isExpanded ? 'ion ion-ios-arrow-down' : 'ion ion-ios-remove'"></i>
        </div>
      </div>
    </div>
    <div v-if="isExpanded" class="card-body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseAccordion',
  props: {
    title: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isExpanded: this.isOpen
    };
  },
  watch: {
    isOpen(val) { this.isExpanded = val; }
  },
  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded;
      this.$emit('toggle');
    }
  }
};
</script>
<style>
.expandButton {
  width: 28px;
  height: 26px;
  border-radius: 4px;
  background-color: #E8E8E8;
  flex-shrink: 0;
}
.dark-style .expandButton{
  background-color: #51555E;
}
.ion{
  color: #131415;
}
.dark-style .ion{
  color: #FFFFFF;
}
</style>
